import { Form } from '@evertel/schema-parser'
import { Row } from './Row'
import { SpacerWidget } from './SpacerWidget'
import { UnknownWidget } from './UnknownWidget'

import { CheckboxWriteWidget } from './CheckboxWidget'
import { DateWriteWidget } from './DateWidget'
import { DropdownWriteWidget } from './DropdownWidget'
import { ListWriteWidget } from './ListWidget'
import { MapWriteWidget } from './MapWidget'
import { MediaWriteWidget } from './MediaWriteWidget'
import { TextWriteWidget } from './TextWidget'
import { UserWriteWidget } from './UserWidget'

const WriteWidgets = {
    form: Form,
    row: Row,
    spacer: SpacerWidget,
    unknown: UnknownWidget,

    checkbox: CheckboxWriteWidget,
    'checkbox-group': CheckboxWriteWidget,
    date: DateWriteWidget,
    dropdown: DropdownWriteWidget,
    list: ListWriteWidget,
    map: MapWriteWidget,
    media: MediaWriteWidget,
    text: TextWriteWidget,
    title: TextWriteWidget,
    user: UserWriteWidget
}

export {
    WriteWidgets
}
